import { CompetencyEntry } from './types'

export const formatPercent = (value?: number | null, fractionDigits = 0) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '–'
  }
  return `${(value * 100).toFixed(fractionDigits)}%`
}

export const formatScore = (value?: number | null, fractionDigits = 0) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '–'
  }
  return `${value.toFixed(fractionDigits)}%`
}

export const formatNumber = (value?: number | null) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '0'
  }
  return new Intl.NumberFormat('de-DE').format(value)
}

export const formatDateTime = (value?: string | null) => {
  if (!value) {
    return '–'
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return '–'
  }
  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const getCompetencyDisplayName = (competency: CompetencyEntry): string => {
  if (competency.childFriendlyName && competency.childFriendlyName.trim() !== '') {
    return competency.childFriendlyName
  }
  return competency.name
}
